import http from 'plugins/axios';

export default {

  //动态查寻列表
  getOrderList(){
    return http.post({
      url:'/la/admin/entrust/findAll',
      data:{
        limit:25,symbolId:7
      }
    })
  },
//撤销订单
cancleOrder(orderId){
  return http.post({
    url:`/la/admin/entrust/${orderId}/cancel`
  })
},
//查询成交列表明细
getOrderDetails(data){
  return http.post({
    url:'/la/admin/entrust/detail-list',
    data
  })
},
 
 
  
};
